import React from 'react'
import styled from 'styled-components'
import { themeGet, space } from 'styled-system'
import { Link } from 'react-static'
import { Icon } from 'components'

const TagSpan = styled.span`
  font-weight: normal;
  display: inline-block;
  color: ${themeGet('colors.primary.0')};
  &:hover {
    color: ${themeGet('colors.primary.1')};
  }
`

const TagIcon = styled(Icon)`
  vertical-align: middle;
`

const BoxLink = styled(Link)`
  ${space}
`

const Tag = ({ tag, ...rest }) => (
  <BoxLink {...rest} to={`/writing/tags/${tag.slug}/`}>
    <TagSpan>
      <TagIcon color="inherit" name="tag" /> {tag.title}
    </TagSpan>
  </BoxLink>
)
export default Tag



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Tag.js